/**
 * @fileoverview
 * Check Box Component - Custom checkbox component
 * Migrated to new architecture with OnPush change detection
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { Component, Input, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';


@Component({
  selector: 'app-check-box',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './check-box.component.html',
  styleUrl: './check-box.component.css',
})
export class CheckBoxComponent {
  @Input() label: string = '';
  @Input() labelRight: boolean = false;
  private _checked: boolean = false;

  @Input()
  set checked(value: boolean) {
    this._checked = value;
  }

  get checked(): boolean {
    return this._checked;
  }

  @Output() checkedChange = new EventEmitter<boolean>();

  toggleCheck() {
    this._checked = !this._checked;
    this.checkedChange.emit(this._checked);
  }
}

